import { Col, Row } from 'antd';
import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { GetLocalStorageValue } from '../../../_config/utils/get-local-storage-value.util';
import CustomCard from '../../../v2-components/Antd/Card';
import CustomSearch from '../../../v2-components/Antd/Search';
import { CustomNotification } from '../../../v2-components/Notification';
import { LOCAL_STORAGE } from '../../../v2-config/constants/local-storage.constant';
import PharmacyLocalsListTable from './components/ListView';
import { handleSearchParams } from './handle/search-params.handle';

import './style.scss';

import { Service } from '../service';
import Loading from '../../../v2-components/Loading';

export default function PharmacyLocalsListPage() {
	const history = useHistory();
	const location = useLocation();
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(false);
	const [data, setData] = useState();
	const searchParams = new URLSearchParams(location?.search);
	const paramPage = searchParams.get('page') || 1;
	const nameLocalQueryParam = searchParams.get('name_local');
	const [nameLocal, setNameLocal] = useState(nameLocalQueryParam);
	const [nameLocalSearchText, setNameLocalSearchText] = useState('');
	const { pharmacy } = GetLocalStorageValue(LOCAL_STORAGE.USER);

	const dataSource = data?.data;
	const pagination = {
		currentPage: data?.currentPage,
		pageSize: data?.itemsPerPage,
		totalItems: data?.totalItems,
	};

	useEffect(() => {
		new Service()
			.getAll(paramPage, nameLocal, pharmacy)
			.then((response) => {
				setData(response);
				setLoading(false);
			})
			.catch((error) => {
				CustomNotification({ success: false, message: null, description: 'Hubo un problema obteniendo los recursos' });
				setError(true);
				console.log('error response: ', error);
			});
	}, [paramPage, nameLocal, pharmacy]);

	const handlePageChange = (page) => {
		searchParams.set('page', page);
		const newSearchParmas = searchParams.toString();
		history.push({
			pathname: location?.pathname,
			search: newSearchParmas,
		});
	};

	const handleSearchValueChange = (e) => {
		setNameLocalSearchText(e.target.value);
	};

	const handleSearch = (nameLocal) => {
		searchParams.set('page', 1);
		searchParams.set('name_local', nameLocal);
		setNameLocal(nameLocal);
		if (!nameLocal) {
			searchParams.delete('name_local');
			setNameLocal(null);
		}
		history.push({
			pathname: location?.pathname,
			search: handleSearchParams(searchParams),
		});
	};

	if (loading) {
		return <Loading /> ;
	}

	return (
		<Row justify={'center'} className="own-pharmacy-locals-list-page">
			<Col span={22}>
				<h1>Sucursales</h1>
				<CustomCard className="own-card-container">
					<h2>Farmacias y sucursales</h2>
					<Row justify={'space-between'}>
						<Col span={10}>
							<CustomSearch
								className="own-search-pharmacy"
								placeholder={'Buscar por nombre'}
								onChange={handleSearchValueChange}
								onSearch={() => handleSearch(nameLocalSearchText)}
							/>
						</Col>
					</Row>

					<PharmacyLocalsListTable
						onPageChange={handlePageChange}
						dataSource={dataSource}
						pagination={pagination}
						loading={loading}
						error={error}
					/>
				</CustomCard>
			</Col>
		</Row>
	);
}
